













































































































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';
import DownloadIcon from 'mdi-vue/Download';
import FilterIcon from 'mdi-vue/Filter';
import { mapState } from 'vuex';

import api from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import TagInput from '@/components/TagInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SummaryBox from '@/components/SummaryBox.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import hasPermission from '@/libs/permission';

import channels, { Channel } from '@/configs/paymentChannels';

import ReportTable from './InstantPaymentReportTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    FormInput,
    TagInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    Tab,
    SummaryBox,
    SearchIcon,
    ExportIcon,
    DatePicker,
    SearchField,
    SearchRow,
    Select,
    ReportTable,
    DownloadIcon,
    FilterIcon,
  },
  methods: {
    hasPermission,
  },
  computed: mapState(['user']),
})

export default class InstantPaymentReport extends Vue {
  user!: {
    user: User;
  };

  channels = channels;

  currentChannel: Channel = {
    title: '', code: '', path: '', type: '', permission: '',
  };

  searchOpen = false;

  transactionDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  paymentDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  selectedMerchants: { merchant_code: string; merchant_name: string } | null = null;
  selectedCompcode: { credentials: string } | null = null;
  transactionStatus: { label?: string; value?: string } = {
    label: 'All Status',
  }

  generalSearch = ''

  loadingMerchant = false;
  loadingSummaryTraffic = false;
  loadingSummaryAmount = false;
  loadingExport = false;

  summaryTraffic = 0;
  summaryAmount = 0;

  summaryTrafficOption = {
    label: 'All Status',
    value: 'all',
  };

  summaryAmountOption = {
    label: 'All Status',
    value: 'all',
  };

  merchants = [
    {
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
    },
  ];

  compcodeList = [
    {
      merchant_code: '',
    },
  ];

  summaryStatusOptions = [
    {
      label: 'All Status',
      value: 'all',
    },
    {
      label: 'Success',
      value: '00',
    },
    {
      label: 'Failed',
      value: '02',
    },
    {
      label: 'Time Out',
      value: '03',
    },
    {
      label: 'Unpaid',
      value: '04',
    },
  ];

  transactionStatusOptions = [
    {
      label: 'All Status',
      value: 'all',
    },
    {
      label: 'Success',
      value: '00',
    },
    {
      label: 'Failed',
      value: '02',
    },
    {
      label: 'Time Out',
      value: '03',
    },
    {
      label: 'Unpaid',
      value: '04',
    },
  ];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  internal = '';

  $refs!: {
    report: ReportTable;
  }

  urls = false;

  checkURL(val: any) {
    if (val === 0) {
      this.urls = false;
    } else {
      this.urls = true;
    }
  }

  format!: (val: string) => string;
  hasPermission!: (val: string) => boolean;

  beforeMount() {
    this.currentChannel = this.channels[this.$route.params.channel];
  }

  mounted() {
    this.parseParams();

    this.summaryTrafficOption = this.summaryStatusOptions.find((e) => e.value === this.$route.query.ts) || {
      label: 'All Status',
      value: 'all',
    };
    this.summaryAmountOption = this.transactionStatusOptions.find((e) => e.value === this.$route.query.ts) || {
      label: 'All Status',
      value: 'all',
    };

    this.getSummary('traffic', this.summaryTrafficOption.value);
    this.getSummary('amount', this.summaryAmountOption.value);
  }

  @Watch('$route')
  onRouteChange() {
    this.currentChannel = this.channels[this.$route.params.channel];
    this.getSummary('traffic', this.summaryTrafficOption.value);
    this.getSummary('amount', this.summaryAmountOption.value);
    this.parseParams();
  }

  @Watch('summaryTrafficOption')
  onSummaryTrafficOptionChange() {
    this.getSummary('traffic', this.summaryTrafficOption.value);
  }

  @Watch('summaryAmountOption')
  onSummaryAmountOptionChange() {
    this.getSummary('amount', this.summaryAmountOption.value);
  }

  @Watch('selectedMerchants')
  async getCompcode() {
    if (this.selectedMerchants !== null) {
      try {
        const { data } = await api.get('/credential/list/', {
          params: {
            service: this.currentChannel.code,
            merchant_code: this.selectedMerchants.merchant_code,
          },
        });
        this.compcodeList = data.data;
      } catch (err) {
        console.error(err);
      }
    }
  }

  async getSummary(type: 'amount' | 'traffic', status: string) {
    try {
      if (type === 'amount') {
        this.loadingSummaryAmount = true;
      } else {
        this.loadingSummaryTraffic = true;
      }

      const transactionDate = {
        startDate: this.transactionDate.startDate === null ? undefined
          : dayjs(this.transactionDate.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: this.transactionDate.endDate === null ? undefined
          : dayjs(this.transactionDate.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };

      const paymentDate = {
        startDate: this.paymentDate.startDate === null ? undefined
          : dayjs(this.paymentDate.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: this.paymentDate.endDate === null ? undefined
          : dayjs(this.paymentDate.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
      };

      const merchants = this.selectedMerchants === null ? undefined
        : this.selectedMerchants.merchant_code;
      const compcode = this.selectedCompcode === null ? undefined
        : this.selectedCompcode.credentials;

      const { data } = await api.get(`/transaction/summary/${this.currentChannel.code}/${type}/all`, {
        params: {
          status: status !== 'all' ? status : undefined,
          startDate: transactionDate.startDate,
          endDate: transactionDate.endDate,
          paymentStartDate: paymentDate.startDate,
          paymentEndDate: paymentDate.endDate,
          'merchantCode[]': merchants,
          credential: compcode,
          transactionNo: undefined,
          customerName: undefined,
          amount: undefined,
          description: undefined,
          reason: undefined,
          userId: undefined,
          general: this.generalSearch.length === 0 ? undefined : this.generalSearch,
        },
      });

      if (type === 'amount') {
        this.loadingSummaryAmount = false;

        if (data.status) {
          this.summaryAmount = data.data;
        } else {
          this.summaryAmount = 0;
        }
      } else {
        this.loadingSummaryTraffic = false;

        if (data.status) {
          this.summaryTraffic = data.data;
        } else {
          this.summaryTraffic = 0;
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  async getMerchants(query: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      const { data } = await api.get(`/merchants/service/${this.currentChannel.code}`, {
        params: {
          name: query,
        },
      });
      this.merchants = data.data;
      this.loadingMerchant = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getTransaction(isExport = false) {
    const params = {
      channel: this.currentChannel,
      transactionDate: this.transactionDate,
      paymentDate: this.paymentDate,
      merchants: this.selectedMerchants,
      transactionStatuses: [],
      transactionStatus: this.transactionStatus,
      transactionNumbers: [],
      compcode: this.selectedCompcode,
      userIds: [],
      customerNames: [],
      amountTotals: [],
      descriptions: [],
      reasons: [],
      generalSearch: this.generalSearch,
    };

    if (isExport) {
      await this.$refs.report.export(params);
    } else {
      await this.$refs.report.getTransaction(params, false);
    }
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.td === 'string') {
      const dates = params.td.split(',');
      this.transactionDate = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    } else {
      this.transactionDate = {
        startDate: null,
        endDate: null,
      };
    }

    if (typeof params.pd === 'string') {
      const dates = params.pd.split(',');
      this.paymentDate = {
        startDate: dayjs(dates[0]).toDate().toString(),
        endDate: dayjs(dates[1]).toDate().toString(),
      };
    } else {
      this.paymentDate = {
        startDate: null,
        endDate: null,
      };
    }

    if (typeof params.gs === 'string') {
      this.generalSearch = params.gs;
    } else {
      this.generalSearch = '';
    }

    if (typeof params.mc === 'string') {
      const merchant = JSON.parse(params.mc);
      this.selectedMerchants = merchant;
    } else {
      const value = this.user.user.is_internal === 0
        ? { merchant_code: this.user.user.merchant.merchant_code, merchant_name: '' } : null;
      this.selectedMerchants = value;
    }

    if (typeof params.cc === 'string') {
      const compcode = JSON.parse(params.cc);
      this.selectedCompcode = compcode;
    } else {
      this.selectedCompcode = null;
    }

    if (typeof params.ts === 'string') {
      const status = this.transactionStatusOptions.find((e) => e.value === params.ts);
      this.transactionStatus = {
        label: status?.label,
        value: status?.value === 'all' ? undefined : status?.value,
      } || {
        label: 'All Status',
      };
    } else {
      this.transactionStatus = {
        label: 'All Status',
      };
    }

    this.getTransaction(false);
  }

  search() {
    const td = this.transactionDate.startDate === null || this.transactionDate.endDate === null ? undefined : {
      start: dayjs(this.transactionDate.startDate).format('YYYY-MM-DD'),
      end: dayjs(this.transactionDate.endDate).format('YYYY-MM-DD'),
    };

    const pd = this.paymentDate.startDate === null || this.paymentDate.endDate === null ? undefined : {
      start: dayjs(this.paymentDate.startDate).format('YYYY-MM-DD'),
      end: dayjs(this.paymentDate.endDate).format('YYYY-MM-DD'),
    };

    this.$router.push({
      query: {
        td: td && `${td.start},${td.end}`,
        pd: pd && `${pd.start},${pd.end}`,
        mc: this.selectedMerchants === null ? undefined : JSON.stringify(this.selectedMerchants),
        cc: this.selectedCompcode === null ? undefined : JSON.stringify(this.selectedCompcode),
        tn: undefined,
        ts: this.transactionStatus.value === 'all' ? undefined : this.transactionStatus.value,
        cn: undefined,
        dc: undefined,
        ch: undefined,
        at: undefined,
        rs: undefined,
        gs: this.generalSearch.length === 0 ? undefined : this.generalSearch,
      },
    });
  }

  async exportData() {
    this.loadingExport = true;
    await this.getTransaction(true);
    this.loadingExport = false;
  }

  cancel() {
    this.transactionDate = {
      startDate: null,
      endDate: null,
    };
    this.paymentDate = {
      startDate: null,
      endDate: null,
    };
    this.selectedMerchants = null;
    this.selectedCompcode = null;
    this.transactionStatus = {
      label: 'All Status',
    };
    this.generalSearch = '';

    this.$router.push({
      query: {},
    });
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }
}
